/** @jsxImportSource @emotion/react */
import { useEffect, useState, useRef } from 'react'
import { createEmbeddingContext, EmbeddingContext } from 'amazon-quicksight-embedding-sdk'

import { useLazyGetQuickSightEmbedUrlQuery } from 'store/services/managementReports'

export const Analytics = () => {
  const [dashboardId, setDashboardId] = useState<string>('6a2a8334-e448-41f1-bb8c-b9abe53b7163')
  const ecRef = useRef<EmbeddingContext>()
  const [getEmbedUrl] = useLazyGetQuickSightEmbedUrlQuery()

  useEffect(() => {
    const handleDashboardChange = async (id: string) => {
      document.querySelectorAll('iframe').forEach((iframe) => iframe.remove())
      const { url } = await getEmbedUrl({ dashboardId: id, userType: 'DME' }).unwrap()

      if (!ecRef.current) {
        ecRef.current = await createEmbeddingContext()
      }
      const container = document.getElementById('quicksight')
      if (!container) return
      console.log('embedding dashboard', url)
      ecRef.current.embedDashboard({
        url,
        container,
        height: '100%',
        width: '100%',
      })
    }

    handleDashboardChange(dashboardId)
  }, [dashboardId])

  return (
    <div
      css={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
        gap: '12px',
      }}>
      <div
        role="note"
        css={{
          flexShrink: 0,
          padding: '12px 16px',
          borderRadius: '8px',
          border: '1px solid #b8d8ff',
          backgroundColor: '#eef6ff',
          color: '#143a5c',
          fontSize: '14px',
          lineHeight: 1.5,
        }}>
        Use the date range controls in the dashboard to update the analytics period.
      </div>
      <div
        id="quicksight"
        css={{
          flex: 1,
          minHeight: 0,
        }}
      />
    </div>
  )
}

export default Analytics
